import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { ErrorMessage, KiloClassCoachRole, KiloClassCoachRoleWrite } from 'types';
import { client } from 'utils/api-client';

export default function useCreateClassCoachRole(): UseMutationResult<
  AxiosResponse<KiloClassCoachRole>,
  AxiosError<ErrorMessage>,
  KiloClassCoachRoleWrite
> {
  const queryClient = useQueryClient();

  const createClassCoachRole = (
    kiloClassCoachRole: KiloClassCoachRoleWrite,
  ): Promise<AxiosResponse<KiloClassCoachRole>> => {
    return client.post('kilo-class-coach-roles/', kiloClassCoachRole);
  };

  return useMutation(createClassCoachRole, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['classCoachRoles'],
      });
      queryClient.invalidateQueries({
        queryKey: ['classPayRateLookups'],
      });
    },
  });
}
